import React from "react";
import PropTypes from "prop-types";

import SFCheckbox from "../../../checkbox";
import classes from "./index.module.scss";

const SFCheckboxCellRenderer = (props) => {
  return (
    <div className={classes.checkbox}>
      <SFCheckbox
        disabled
        checked={props.value}
      />
    </div>
  );
};

SFCheckboxCellRenderer.propTypes = {
  value:PropTypes.bool
};

export default SFCheckboxCellRenderer;